module.exports = __webpack_public_path__ + "img/background.d19be837.png";